import bl from './bl-config'

const search = { ...bl.search }

search.inputs = bl.search.inputs.slice()
search.inputs[0] = {
  type: 'InputSelect',
  title: 'Type',
  span: 6,
  options: 'getters/search/blPageTypeAll',
  getter: 'state/search/orderType',
  setter: 'commit/search/setOrderType',
  defaultValue: 5
}

const edit = { ...bl.edit }
const draft = { ...bl.draft }

export default { search, edit, draft, approve: draft }
